function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// We will just add multiple reporting addon types here when we need them.
// E.g: ConvivaAddonConfig | ComscoreAddonConfig | AdobeAddonConfig;
export var ReportingAddon = /*#__PURE__*/ function() {
    "use strict";
    function ReportingAddon() {
        _class_call_check(this, ReportingAddon);
        _define_property(this, "name", '');
    }
    _create_class(ReportingAddon, [
        {
            key: "setupAdvertising",
            value: function setupAdvertising(data) {}
        }
    ]);
    return ReportingAddon;
}();
_define_property(ReportingAddon, "requiresUserConsentToBeUsed", false);

//# sourceMappingURL=reporting-addon.js.map